import React from 'react';
import Counter          from '../../components/Counter';

class SafetyItem extends React.Component {

  isContent(val) {
    if(val === null || val === '' || val === undefined ){
      return false;
    } else {
      return true;
    }
  }

  onChange = (number) => {
    this.props.onChange(this.props.propsName, number);
  }

  render() {
    const { age, image, title, weight, className ='' } = this.props;

    return (
      <li className={"list-safety__item " + className}>
        <div className="list-safety__image">
          <div>
            <img src={image} />
          </div>
        </div>

        <div className="list-safety__desc">
          <div>
            <p className="list-safety__title">{title}</p>
            { this.isContent(weight) &&
              <p className="list-safety__details">
                <span>{weight}</span>
                <span>{age}</span>
              </p>
            }

          </div>
        </div>

        <div className="list-safety__counter">
          <div className="counter">
            <Counter
              number={this.props.number}
              onChange={this.onChange}
              disableIncrement={this.props.disableIncrement}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default SafetyItem;
